export class ProfileInfo {
    public activeProfiles: string[];
    public ribbonEnv: string;
    public inProduction: boolean;
    public swaggerEnabled: boolean;
}
